export const MODAL_TYPES = Object.freeze({
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  PICKUP_DELIVERY_SELECTION: 'PICKUP_DELIVERY_SELECTION',
  CART_DRAWER: 'CART_DRAWER',
  PICKUP_STORE_SELECTION: 'PICKUP_STORE_SELECTION',
  DELIVERY_ADDRESS_SELECTION: 'DELIVERY_ADDRESS_SELECTION',
  DATE_TIME_SELECTION: 'DATE_TIME_SELECTION',
  CHECKOUT_PROMOTION_SELECTION: 'CHECKOUT_PROMOTION_SELECTION',
  REFRESH_BROWSER: 'REFRESH_BROWSER',
  CLEAR_CART_ITEMS: 'CLEAR_CART_ITEMS',
  ERROR_MODAL: 'ERROR_MODAL',
  CHECKOUT_FAILED_PROMOTION: 'CHECKOUT_FAILED_PROMOTION',
  CHECKOUT_PROMOTION_ITEM: 'CHECKOUT_PROMOTION_ITEM',
  CHECKOUT_PROMOTION_SUMMARY: 'CHECKOUT_PROMOTION_SUMMARY',
  CHECKOUT_PROMOTION_REMOVAL: 'CHECKOUT_PROMOTION_REMOVAL',
  CHECKOUT_PROMOTION_FAILED_WITH_CARD: 'CHECKOUT_PROMOTION_FAILED_WITH_CARD',
  PROMOTION_DETAILS: 'PROMOTION_DETAILS',
  MARKETING_POPUP: 'MARKETING_POPUP',
  NEWSLETTER_SIGNUP: 'NEWSLETTER_SIGNUP',
  REMINDER_ORDER: 'REMINDER_ORDER',
  CHECKOUT_EXIT_CONFIRMATION: 'CHECKOUT_EXIT_CONFIRMATION',
  FOREIGN_PHONE_NUMBER: 'FOREIGN_PHONE_NUMBER',
  VOUCHERS_SELECTOR: 'VOUCHERS_SELECTOR',
  VOUCHER_DETAILS: 'VOUCHER_DETAILS',
  LOADING_OVERLAY: 'LOADING_OVERLAY',
  DELIVERY_PARTY: 'DELIVERY_PARTY',
  SELECT_CALENDAR: 'SELECT_CALENDAR',
  DOWNLOAD_CALENDAR_FILE: 'DOWNLOAD_CALENDAR_FILE',
  SHARE_APP: 'SHARE_APP',
  E_INVOICE: 'E_INVOICE',
  CONTACT_RESTAURANT: 'CONTACT_RESTAURANT',
  NEED_HELP: 'NEED_HELP',
  CONTACT_LOGISTIC: 'CONTACT_LOGISTIC',
})
